export default __webpack_public_path__ + "static/placement-dont-light-5deb666c7c07c22907a2166f9139ed5f.png";